import { fakerSV } from '@faker-js/faker';
import userEvent from '@testing-library/user-event';
// @ts-ignore
import kungalv from '../../data/kungalv.json';
// @ts-ignore
import goteborg from '../../data/goteborg.json';

type Address = {
    street: string;
    zip: string;
    city: string;
};

export const PRODUCT_PANEL_ID = 'select-product-section';
export const PACKAGE_PRODUCT_ID = 'package-product';
export const ORDER_INFORMATION_PANEL_ID = 'order-information-section';

function delay(callback: () => void): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(() => {
            callback();
            resolve();
        }, 100);
    });
}

function toggleProducts() {
    let productPanel = document.getElementById(PRODUCT_PANEL_ID);
    productPanel.getElementsByTagName('a')[0].click();
}

function selectFirstPackageProduct() {
    let packageProduct = document.getElementById(`${PACKAGE_PRODUCT_ID}_0`);

    let event = new MouseEvent('mouseup', {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: 20
    });

    packageProduct.dispatchEvent(event);
}

async function toggleOrderInformation() {
    let orderInformationPanel = document.getElementById(ORDER_INFORMATION_PANEL_ID);
    await userEvent.click(orderInformationPanel.getElementsByTagName('a')[0]);
}

async function fillOwnerInformation() {
    let ownerFirstName = document.getElementById('contact.OwnerFirstName');
    let firstName = fakerSV.person.firstName();
    await userEvent.type(ownerFirstName, firstName);

    let ownerLastName = document.getElementById('contact.OwnerLastName');
    let lastName = fakerSV.person.lastName();
    await userEvent.type(ownerLastName, lastName);

    let ownerEmail = document.getElementById('contact.OwnerEmailAddress');
    let email = fakerSV.internet.email({ provider: 'example.com' });
    await userEvent.type(ownerEmail, email);

    // TODO: Add when phone number input works for owner...
    // let ownerPhone = document.getElementById('contact.OwnerPrimaryPhoneNumber');
    // await userEvent.type(ownerPhone, '+46 71 111 11 11');
}

async function preparation() {
    toggleProducts();
    selectFirstPackageProduct();

    await delay(() => {
        toggleOrderInformation();
    });

    await fillOwnerInformation();
}

async function fillAddress(address: Address) {
    let streetInput = document.getElementById('address.AddressLine1');
    await userEvent.type(streetInput, address.street);
    
    let zipInput = document.getElementById('address.AddressPostalNumber');
    await userEvent.type(zipInput, address.zip);
    
    let cityInput = document.getElementById('address.AddressCity');
    await userEvent.type(cityInput, address.city);
}

function getRandomAddress(addresses: Address[]): Address {
    return addresses[Math.floor(Math.random() * addresses.length)];
}

async function setAsApartment() {
    let objectTypeInput = document.getElementById('address.ObjectType');
    await userEvent.selectOptions(objectTypeInput, ['1']);
}

async function setAsHouse() {
    let objectTypeInput = document.getElementById('address.ObjectType');
    await userEvent.selectOptions(objectTypeInput, ['2']);
}

async function acceptTerms() {
    let termsCheckbox = document.getElementById('order.agreementAccepted');
    await userEvent.click(termsCheckbox);
}

export async function fillForm__Goteborg_Apartment() {
    await preparation();

    let addresses = goteborg.addresses;
    let randomAddress = getRandomAddress(addresses);
    await fillAddress(randomAddress);

    await setAsApartment();

    await acceptTerms();
}

export async function fillForm__Goteborg_House() {
    await preparation();

    let addresses = goteborg.addresses;
    let randomAddress = getRandomAddress(addresses);
    await fillAddress(randomAddress);

    await setAsHouse();

    await acceptTerms();
}

export async function fillForm__Kungalv_Apartment() {
    await preparation();
    
    let addresses = kungalv.addresses;
    let randomAddress = getRandomAddress(addresses);
    await fillAddress(randomAddress);
    
    await setAsApartment();
    
    await acceptTerms();
}

export async function fillForm__Kungalv_House() {
    await preparation();
    
    let addresses = kungalv.addresses;
    let randomAddress = getRandomAddress(addresses);
    await fillAddress(randomAddress);

    await setAsHouse();

    await acceptTerms();
}
